import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface TextProps {
  children: string
  className?: string
}

const StyledText = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xsmall: { bundledCSS: bodycopyXSmallCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${bodycopyXSmallCSS};
    color: ${textDefault};
  `}
`
const Text: FunctionComponent<TextProps> = ({ children, className }) => (
  <StyledText className={className}>{children}</StyledText>
)

export default Text
